import { WorkspaceType } from 'hooks/globalApi';
import { WorkspaceRoleKey } from 'hooks/internalApi';
import { useWorkspace } from 'hooks/useWorkspace';
import { workspaceRoleLabels } from 'utils/workspaceRoles';

export const useWorkspaceRoleOptions = () => {
  const { workspace } = useWorkspace();
  const isFreeTier = workspace?.type === WorkspaceType.FreeTierLedger;
  const roles = isFreeTier
    ? [WorkspaceRoleKey.FreeTierAdmin, WorkspaceRoleKey.FreeTierReader]
    : [WorkspaceRoleKey.WorkspaceAdmin, WorkspaceRoleKey.WorkspaceReader];
  const defaultRole = isFreeTier
    ? WorkspaceRoleKey.FreeTierAdmin
    : WorkspaceRoleKey.WorkspaceAdmin;

  if (!workspace) return { roleOptions: [], defaultRole };

  const roleOptions = roles.map((role) => ({
    value: role,
    label: workspaceRoleLabels[role],
  }));

  return { roleOptions, defaultRole };
};
